import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';

const missionWords = [
  {
    get word() {
      return t('extra.expert');
    },
    size: 'text-2xl',
    weight: 'font-normal',
    style: 'italic',
    align: 'self-start ms-0',
  },
  {
    get word() {
      return t('extra.secure');
    },
    size: 'text-5xl',
    weight: 'font-bold',
    style: '',
    align: 'self-center ms-auto',
  },
  {
    get word() {
      return t('extra.simple');
    },
    size: 'text-6xl',
    weight: 'font-bold',
    style: '',
    align: 'self-center mx-auto',
  },
  {
    get word() {
      return t('extra.scalable');
    },
    size: 'text-3xl',
    weight: 'font-semibold',
    style: '',
    align: 'self-start ms-8',
  },
  {
    get word() {
      return t('extra.swift');
    },
    size: 'text-3xl',
    weight: 'font-normal',
    style: 'italic',
    align: 'self-end ms-auto me-16',
  },
  {
    get word() {
      return t('extra.humanCentric');
    },
    size: 'text-4xl',
    weight: 'font-bold',
    style: '',
    align: 'self-end ms-0',
  },
  {
    get word() {
      return t('extra.traceable');
    },
    size: 'text-4xl',
    weight: 'font-semibold',
    style: '',
    align: 'self-center ms-auto me-0',
  },
];

export const AboutUsSection = ({ className }: { className?: string }) => {
  useLocale();

  return (
    <section className={className} id="about-us">
      <div className="mx-auto max-w-4xl px-6 lg:px-10">
        {/* Badge */}
        <span className="mb-4 inline-block rounded-full bg-landing-pill-bg px-3 py-1 font-medium text-landing-pill-text text-xs">
          {t('landing.aboutUs')}{' '}
        </span>

        {/* Heading */}
        <h2 className="mb-3 font-bold font-libre-baskerville text-4xl text-landing-heading">
          {t('landing.complianceReimaginedForHumans')}{' '}
        </h2>

        {/* Subtitle */}
        <p className="mb-6 text-landing-body text-sm leading-relaxed">
          {t('landing.ravenExistsToGiveComplianceTeamsTheirTimeBack')}{' '}
        </p>

        {/* Body 1 */}
        <p className="mb-4 text-landing-body text-sm leading-relaxed">
          {t('landing.weCombine')}{' '}
          <span className="font-semibold text-primary">
            {t('landing.deepExpertiseWithAHumanFirstApproach')}{' '}
          </span>{' '}
          {t('landing.toTurnComplianceFromABottleneckIntoASeamless')}{' '}
        </p>

        {/* Body 2 */}
        <p className="mb-12 text-landing-body text-sm leading-relaxed">
          {t('landing.everyLayerOfOurPlatformIsBuiltTo')}{' '}
          <em className="font-libre-baskerville text-landing-heading-sm">
            {t('landing.reduceFriction')}
          </em>
          ,{' '}
          <em className="font-libre-baskerville text-landing-heading-sm">
            {t('landing.increaseTransparency')}
          </em>
          {t('landing.and')}{' '}
          <em className="font-libre-baskerville text-landing-heading-sm">
            {t('landing.scaleWithYou')}
          </em>{' '}
          {t('landing.withoutCompromisingOnSecurityOrPrecision')}{' '}
        </p>

        {/* Our Missions divider */}
        <div className="my-10 flex items-center gap-4">
          <hr className="flex-1 border-landing-card-border" />
          <span className="whitespace-nowrap font-medium text-landing-muted text-sm">
            {t('landing.ourMissions')}{' '}
          </span>
          <hr className="flex-1 border-landing-card-border" />
        </div>

        {/* Word cloud */}
        <div className="relative flex h-96 flex-col gap-4 overflow-hidden">
          {missionWords.map(({ word, size, weight, style, align }) => (
            <span
              className={`${size} ${weight} ${style} ${align} select-none font-libre-baskerville text-landing-heading leading-none`}
              key={word}
            >
              {word}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
